import Header from "../../components/public/Header";
import Hero from "../../components/public/Hero";
import About from "../../components/public/About";
import Achievements from "../../components/public/Achievements";
import Testimonials from "../../components/public/Testimonials";
import Capability from "../../components/public/Capability";
import Clients from "../../components/public/Clients";
import MarqueeDataRibbon from "../../components/public/MarqueeDataRibbon";
import Footer from "../../components/public/Footer";
import usePageMeta from "../../hooks/usePageMeta";

export default function PublicHome() {
  usePageMeta({
    title: "Bon-Heur Pharmaceuticals — Innovation is our DNA",
    description: "WHO-GMP certified pharmaceutical manufacturer based in Haridwar with 1000+ commercialised formulations and 100+ DCGI approvals. Tablets, capsules, oral liquids, dry injections and external applications.",
    keywords: "Bon-Heur Pharmaceuticals, WHO-GMP, pharmaceutical manufacturer India, Haridwar pharma, tablets, capsules, dry injections, cephalosporins",
  });
  return (
    <div className="min-h-screen bg-[#F7F8F6]" style={{ fontFamily: "'Manrope', sans-serif" }} data-testid="public-home">
      <Header />
      <main>
        <Hero />
        <MarqueeDataRibbon />
        <About />
        <Achievements />
        <Testimonials />
        <Capability />
        <Clients />
      </main>
      <Footer />
    </div>
  );
}
